module.exports = __webpack_public_path__ + "img/Hail.f1b0f196.png";